<h3 nz-title>{{ subheading }}</h3>

<div class="modules">
  <div class="module-box" *ngFor="let module of (modules$ | async)">
    <a *ngIf="module.fullDocumentNavigation; else appRouteLink" class="module" href="{{module.url}}" [id]="module.id+'-link'">
      <ng-container *ngTemplateOutlet="moduleContent"></ng-container>
    </a>
    <ng-template #appRouteLink>
      <a class="module" routerLink="{{module.url}}" [id]="module.id+'-link'">
        <ng-container *ngTemplateOutlet="moduleContent"></ng-container>
      </a>
    </ng-template>
    <ng-template #moduleContent>
      <div class="module_sub-title">
        {{ module.titleLine1 }}
      </div>
      <div class="module_title">
        {{module.titleLine2}}
      </div>
      <div class="module_title">
        {{module.titleLine3}}
      </div>
      <div class="content">
        <img [attr.src]="assetsDir + '/' +  module.icon">
      </div>
      <div class="module_description">
        {{module.description}}
      </div>
    </ng-template>
  </div>
</div>
